export default {
  nav: {
    home: 'Accueil',
    video: 'Vidéosurveillance',
    alarm: "Systèmes d'Alarme",
    solutions: 'Solutions',
    care: 'SSG Care',
    planner: 'Planificateur de Caméras',
    areas: "Zones d'Intervention",
    about: 'À Propos',
    contact: 'Contact',
  },
  dropdown: {
    allSolutions: 'Voir toutes les solutions',
    homeGrounds: 'Maison et Terrain',
    retailGastro: 'Commerce et Restauration',
    officePractice: 'Bureau et Cabinet',
    warehouseLogistics: 'Entrepôt et Logistique',
    workshopTrade: 'Atelier et Commerce',
    apartments: 'Immeubles et Biens Immobiliers',
    cameraTypes: 'Types de Caméras',
    services: 'Services',
    technology: 'Technique',
  },
  footer: {
    brandLine: 'Technologie de sécurité pour particuliers et entreprises',
    area: 'Hainburg · Région Rhin-Main',
    services: 'Services',
    solutions: 'Solutions',
    forWhom: 'Pour Qui',
    contact: 'Contact',
    areaLabel: "Zone d'intervention Rhin-Main",
    privateCustomers: 'Clients particuliers',
    businessCustomers: 'Clients professionnels',
    allSolutions: 'Toutes les solutions',
    faq: 'FAQ',
    rights: 'Tous droits réservés.',
    impressum: 'Mentions légales',
    privacy: 'Politique de confidentialité',
    cookieSettings: 'Paramètres des cookies',
  },
  related: {
    eyebrow: 'Autres solutions',
    title: "Découvrir d'autres types de biens",
    viewAll: 'Voir toutes les solutions',
  },
};